
import { Box, Divider, Typography } from "@mui/material";
import EmailConfCard from '../Register/EmailConfCard';
import LanguageSelector from '../../language';
import ButtonsTextGoTo from '../../components/Button/ButtonTextGo';
import { useTranslation } from "../../language";
import ForgotForm from "./ForgotForm";


export default function ForgotCard() {

  const { t } = useTranslation();

  return (
    <EmailConfCard
      topic=""
      content={<>

        <Box sx={{ mb: 4 }}><LanguageSelector /></Box>

        <Typography variant="h4" gutterBottom>
          {t("reset_1")}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          {t("reset_2")}
        </Typography>

        <ForgotForm />

        <Divider sx={{ mt: 4, mb: 3 }} />

        <Typography variant="subtitle1" fontWeight={400} align="center">
          {t("onb_email7")}
        </Typography>
        <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
          {t("onb_email8")}
        </Typography>
        <ButtonsTextGoTo to="/Login" name={t("onb_email9")} />

      </>}
    />
  );
}
